import React from "react";

export default function ProductStatusBadge({ className, children }) {
  return (
    <div className={className}>
      <span>{children}</span>
    </div>
  );
}
